/* global session */
/* eslint complexity: ["error", 25] */
import swal from 'sweetalert2';
import Vue from 'vue';
import Router from 'vue-router';
import paths from './paths';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import session from '../helpers/session';
import store from '../store';
import Mediator from '../Mediator';
import { getOne, getCollection } from '../helpers/helpers';

let isSetEvents = false;
let systemTables = [];

// start HELPER functions
async function updateUserSession (eventObj) {
  let $session = JSON.parse(JSON.stringify(session.getSession()));
  if (eventObj.data._id !== $session.user._id) return;
  let modifiedUser = JSON.parse(JSON.stringify(eventObj.data));
  let humanId = modifiedUser.human;
  console.log('setting USER session based on document received from mediator', $session);
  console.log('humanId', humanId);
  console.log('modifiedUser', modifiedUser);
  try {
    let humanDocument = await Mediator.client.store.models.Human.get(humanId);
    console.log('humanDocument', humanDocument);
    // see lib/auth/service/mw.service.js on back end
    modifiedUser.human = humanDocument;
    modifiedUser.id = modifiedUser._id;
    modifiedUser.name = humanDocument.first_name + ' ' + humanDocument.last_name;
    modifiedUser.user_email = modifiedUser.username;
    // modifiedUser.agency_id = 'aaaa'
    // modifiedUser.group_id = ''
    modifiedUser.photo = modifiedUser.avatar;
    modifiedUser.user_id = modifiedUser._id;
    modifiedUser.role = modifiedUser.roles[0];
    modifiedUser.user_type = modifiedUser.roles[0];
    $session.user = modifiedUser;
    store.commit('setSession', $session);
    session.setSession($session);
  } catch (e) {
    console.warn('session was not updated', e);
  }
}

async function setInitialData (entity, accountId) {
  if ((entity === 'Account' && Object.keys(store.state.Account).length === 0) || (entity === 'Agency' && Object.keys(store.state.Agency).length === 0) || (entity === 'Child' && Object.keys(store.state.Child).length === 0) || (entity === 'CaseWorker' && Object.keys(store.state.CaseWorker).length === 0)) {
    let populate = [];
    if (['Account', 'Child'].indexOf(entity) > -1) {
      populate = [
        { path: 'human', populate: 'additional_info.jurisdiction.state' },
        'contactInfo.country', 'contactInfo.state', 'template.template'];
    }
    let { error, data } = await getOne(entity, accountId, populate);
    if (error) {
      console.log(error);
    } else {
      store.commit('set' + entity, data);
      if (entity === 'CaseWorker') {
        await setInitialData('Agency', data.agency);
      } 
    }
  }
  /* Set MyAgencies for parent */
  if (entity === 'Account') {
    let account = store.state.Account;
    let adminMenuSettings = await fetchAdminMenuSettings();
    store.state.MenuSettings = adminMenuSettings ? adminMenuSettings : store.state.MenuSettings;
    if (account && account.default_agency && (account.id || account._id)) {
      let where = { 'account.account': account.id || account._id };
      let attributes = 'name,createdAt,account,_id,family_menu_settings';
      let populate = [{ path: 'human', select: '_id name user' }];
      let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes);
      if (error) {
        console.log(error);
      } else {
        store.commit('setMyAgencies', data);
        /* Set the MenuSettings */
        if (data.length) {
          let defaultAgency = data.find(x => x.id === account.default_agency);
          if (defaultAgency && defaultAgency.family_menu_settings) {
            // eslint-disable-next-line
            if (adminMenuSettings) {
              /* Sync with the admin menu settings */
              store.state.MenuSettings = await syncWithAdminMenu(adminMenuSettings, defaultAgency.family_menu_settings);
            } else {
              store.state.MenuSettings = defaultAgency.family_menu_settings;
            }
          }
        }
      }
    }
  }
}

async function fetchAdminMenuSettings () {
  let { error, data, status } = await getCollection('Agency', true, 0, '', { is_super_admin: true }, 'family_menu_settings');
  if (error) {
    console.log('error', error);
  } else {
    data = data && data.length ? data[0] : null;
    if (data && data.family_menu_settings && Object.keys(data.family_menu_settings).length) {
      return data.family_menu_settings;
    }
  }
  return null;
}

async function syncWithAdminMenu (adminMenuSettings, agencySettings) {
  /* Sync with the admin menu settings */
  let settingKeys = Object.keys(adminMenuSettings);
  for (let h = 0; h < settingKeys.length; h++) {
    let adminSection = adminMenuSettings[settingKeys[h]];
    if (!adminSection || !adminSection.length) {
      continue;
    }
    for (let i = 0; i < adminSection.length; i++) {
      let adminSetting = adminSection[i];
      let menuIndex = agencySettings[settingKeys[h]].findIndex(x => x.name === adminSetting.name);
      if (adminSetting && adminSetting.status === 'off') {
        /* Replace the setting */
        if (menuIndex > -1) {
          agencySettings[settingKeys[h]][menuIndex].status = adminSetting.status;
        } else {
          agencySettings[settingKeys[h]].push(adminSetting);
        } 

      }
    }
  }
  return agencySettings;
}

async function setInitialCollection (entity, user) {
  let storeVar = entity === 'Agency' ? 'AgencyList' : entity;
  if (store.state[storeVar].length === 0) {
    let where = user.role === 'admin' ? { _id: { $ne: store.state.Agency.id }} : {};
    let attributes = 'name,createdAt,_id';
    let populate = [{ path: 'human', select: '_id user' }];
    getCollection(entity, true, 0, populate, where, attributes, (error, data, count) => {
      if (error) {
        console.log(error);
      } else {
        store.commit('set' + storeVar, data);
      }
    });
  }
}

async function updateHumanSession (eventObj) {
  let $session = JSON.parse(JSON.stringify(session.getSession()));
  if (eventObj.data._id !== $session.user.human._id) return;
  
  let humanDocument = eventObj.data;
  let userId = humanDocument.user;
  let modifiedUser = await Mediator.client.store.models.User.get(userId);
  let humanId = modifiedUser.human;
  console.log('setting HUMAN session based on document received from mediator', $session);
  console.log('modifiedUser', modifiedUser);
  console.log('humanId', humanId);
  console.log('humanDocument', humanDocument);
  // see lib/auth/service/mw.service.js on back end
  modifiedUser.human = humanDocument;
  modifiedUser.id = modifiedUser._id;
  modifiedUser.name = modifiedUser.human.first_name + ' ' + modifiedUser.human.last_name;
  modifiedUser.user_email = modifiedUser.username;
  // modifiedUser.agency_id = 'aaaa'
  // modifiedUser.group_id = ''
  modifiedUser.photo = modifiedUser.avatar;
  modifiedUser.user_id = modifiedUser._id;
  modifiedUser.role = modifiedUser.roles[0];
  modifiedUser.user_type = modifiedUser.roles[0];
  $session.user = modifiedUser;
  store.commit('setSession', $session);
  session.setSession($session);
}

async function dataSyncEventListener (eventObj) {
  console.log('data:sync', eventObj);
  console.log('eventObj.action', eventObj.action);
  if (eventObj.success) {
    if (eventObj.action === 'update' || eventObj.action === 'create' || eventObj.action === 'restore' || eventObj.action === 'delete') {
      // console.log(Mediator.client.store);
      try {
        let newDocument = await Mediator.client.store.models[eventObj.entity].put(eventObj.data);
        console.log(eventObj.entity, newDocument);
      } catch (e) {
        console.log('error updating doc ', e);
      }

      if (eventObj.entity === 'User') {
        await updateUserSession(eventObj);
      } else if (eventObj.entity === 'Human') {
        await updateHumanSession(eventObj);
      }
    } else if (eventObj.action === 'delete_hard') {
      try {
        let newDocument = await Mediator.client.store.models[eventObj.entity].delete(eventObj.data._id);
        console.log(eventObj.entity, newDocument);
      } catch (e) {
        console.log('error deleting doc ', e);
      }
    }
  }
  // eventObj.action
  // eventObj.entity
  // eventObj.data
}

function setEvents (client) {
  if (isSetEvents) return;

  client.on('mediator:ready', function (eventObj) {
    console.log('Connected to the server!');
    console.log('Type <b>/help</b> for a list of commands.');
  });
  // client.destroyEvent( on_readyEvent );

  client.on('user:join', function (eventObj) {
    console.log(eventObj);
  });
  // client.destroyEvent( on_userJoinEvent );

  client.on('user:disconnect', function (eventObj) {
    console.log(eventObj);
  });

  // Commented by Rafeeque as not used
  // client.on('data:sync', dataSyncEventListener);
  isSetEvents = true;
}

function checkSuspendedAccount () {
  if (store.state.Account && store.state.Account.agency && store.state.Account.agency.length) {
    let suspendedIndex = store.state.Account.agency.findIndex(agency => agency.status === 'Suspended');
    if (suspendedIndex > -1) {
      router.push('/membership');
      return true;
    }
  }
  return false;
}

// end HELPER functions

Vue.use(Router);

const router = new Router({
  base: '/',
  mode: 'hash',
  linkActiveClass: 'active',
  routes: paths
});

// router gards
// eslint-disable-next-line
router.beforeEach(async (to, from, next) => {
  // NProgress.start();

  try {
    if (session.isOnline()) {
      if (window.getApp) {
        window.getApp.$emit('pageSubHeader', '');
        window.getApp.$emit('AppProgress', true);
      }
      let $session = session.getSession();
      let isAdminLogon = $session.adminUser ? 1 : 0;
      let user = $session.user;
      let suspended = false;

      /* Set the account data for parent and agency */
      if (user.role === 'parent' && store.state.Account && Object.keys(store.state.Account).length === 0) {
        await setInitialData('Account', isAdminLogon ? user.human.account.id : 'Me');
        suspended = checkSuspendedAccount();
      } else if (user.role === 'child' && store.state.Child && Object.keys(store.state.Child).length === 0) {
        await setInitialData('Child', isAdminLogon ? user.human.child.id : 'Me');
      } else if (['agency', 'admin'].indexOf(user.role) > -1 && store.state.Agency && Object.keys(store.state.Agency).length === 0) {
        await setInitialData('Agency', isAdminLogon ? user.human.agency : 'Me');
      } else if (user.role === 'caseworker' && store.state.CaseWorker && Object.keys(store.state.CaseWorker).length === 0) {
        await setInitialData('CaseWorker', isAdminLogon ? user.human.caseworker : 'Me');
      }

      /* if (['admin'].indexOf(user.role) > -1 && !store.state.AgencyList.length) {
        setInitialCollection('Agency', user);
      } */

      if (to.meta.roles.indexOf('*') !== -1 || to.meta.roles.indexOf(user.role) !== -1) {

        if (!Mediator || !Mediator.client) {
          Mediator.start($session, () => {
            setEvents(Mediator.client);
            window.getApp.$emit('MEDIATOR_STARTED');
            store.commit('setSession', $session);

          });
        }

        /* Check for suspended accounts */
        if (user.role === 'parent' && to.name !== 'Membership') {
          suspended = checkSuspendedAccount();
        }

        // Check any agency other than default agency enabled payment and no active subscription available
        let agenciesRequiredPayment = [];
        if (user.role === 'parent') {

          // Check if any agency has the payment enabled
          const additionalAgencyIds = store.state.Account.agency.filter(agency => agency.agency !== store.state.Account.default_agency).map(agency => agency.agency);
          if (additionalAgencyIds.length) {
            let { error: agencyError, data: agenciesData } = await getCollection('Agency', true, 10, '', { _id: { $in: additionalAgencyIds }}, 'name,is_additional_display_fee,additional_display_fee');
            if (!agencyError) {
              let agenciesEnabledPayment = agenciesData.filter(agency => agency.is_additional_display_fee && agency.additional_display_fee.amount);
              if (agenciesEnabledPayment.length) {
                const agencyIds = agenciesEnabledPayment.map(agency => agency._id);
                // Check if any of the agency has active subscription
                let { error: subscriptionError, data: subscriptionData } = await getCollection('PaymentSubscription', true, 10, '', { 'account': store.state.Account.id, 'status': 'Subscribed', agency: { $in: agencyIds }});
                if (!subscriptionError) {
                  // Find any agency from agencyIds doesn't have the active subscription
                  let activeSubscriptions = subscriptionData.map(subscription => subscription.agency);
                  agenciesRequiredPayment = agenciesEnabledPayment.filter(agency => !activeSubscriptions.includes(agency._id));
                  store.state.AgenciesRequiredPayment = agenciesRequiredPayment;
                }
              }
            }
          }
        }
        if (!isAdminLogon && user.role === 'parent' && !store.state.Account.agency.length && (['MyAgencies', 'AddAgency', 'Logout'].indexOf(to.name) === -1)) {
          router.push('/agencies');
          swal.fire({
            type: 'warning',
            title: 'Please add your agency to proceed.',
            showConfirmButton: true,
            timer: 2500
          });
          window.getApp.$emit('AppProgress', false);
        } else if (agenciesRequiredPayment.length && (['MyAgencies', 'Logout'].indexOf(to.name) === -1)) {
          router.push('/agencies');
          window.getApp.$emit('AppProgress', false);
        } else if (!suspended) {
          next();
        }
        if (suspended) {
          window.getApp.$emit('AppProgress', false);
        }

      } else {
        router.push('/login');
      }
      // NProgress.done();
    } else if (['Join', 'Login', 'ForgotPassword', 'ForgotUsername'].includes(to.name)) {
      next();
    } else {
      router.push({ path: '/login', query: { requestFrom: 'invalid' }});
    }
  } catch (e) {
    if (window.getApp) {
      window.getApp.$emit('AppProgress', false);
    }
  }
  
});

router.afterEach((to, from) => {
  // NProgress.done();
  /* Collapse the menu for profile layout */
  let isToTop = false;
  if (to.name && ['ProfileDocuments', 'ProfileDocumentsReview', 'ProfileDocumentsAgencyList', 'ChildManagement', 'ChildAdd', 'ChildView', 'ChildAddExisting'].indexOf(to.name) > -1) {
    isToTop = true;
    window.getApp.$emit('FORCE_MINI_DRAWER', true);
  } else {
    window.getApp.$emit('FORCE_MINI_DRAWER', false);
  }
  if (window.getApp && document.getElementById('pageHeader')) {
    // window.getApp.$vuetify.goTo(isToTop ? 0 : '#pageHeader');
    window.getApp.$vuetify.goTo(isToTop ? 0 : (document.getElementById('pageHeader').offsetTop - 70));
    window.getApp.$emit('AppProgress', false);
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js